module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CollectData",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Data Acquisition: test = " + _vm._s(_vm.testParamDefs[_vm.currentTest].name))])]), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(" Graphs:  ")]), _vm._v(" "), _c('md-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeVoltVsTime),
      expression: "includeVoltVsTime"
    }],
    staticClass: "md-primary",
    model: {
      value: (_vm.showVoltVsTime),
      callback: function($$v) {
        _vm.showVoltVsTime = $$v
      },
      expression: "showVoltVsTime"
    }
  }, [_vm._v(" potential vs time ")]), _vm._v(" "), _c('md-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsTime),
      expression: "includeCurrVsTime"
    }],
    staticClass: "md-primary",
    model: {
      value: (_vm.showCurrVsTime),
      callback: function($$v) {
        _vm.showCurrVsTime = $$v
      },
      expression: "showCurrVsTime"
    }
  }, [_vm._v(" current vs time ")]), _vm._v(" "), _c('md-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsVolt),
      expression: "includeCurrVsVolt"
    }],
    staticClass: "md-primary",
    model: {
      value: (_vm.showCurrVsVolt),
      callback: function($$v) {
        _vm.showCurrVsVolt = $$v
      },
      expression: "showCurrVsVolt"
    }
  }, [_vm._v(" current vs potential ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": ""
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "width": "110px"
    },
    on: {
      "click": _vm.onRunClick
    }
  }, [_vm._v(" \n        Run Test\n      ")]), _vm._v(" "), (_vm.showDebugButton) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "width": "110px"
    },
    on: {
      "click": _vm.onDebugClick
    }
  }, [_vm._v(" \n        Debug\n      ")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "disabled": !_vm.saveDataReady
    },
    on: {
      "click": _vm.onSaveDataClick
    }
  }, [_vm._v(" \n        Save Data\n      ")])], 1), _vm._v(" "), _c('md-dialog-prompt', {
    ref: "saveDataDialog",
    attrs: {
      "md-title": "Filename",
      "md-ok-text": "Save",
      "md-cancel-text": "Cancel",
      "md-input-placeholder": "data.txt"
    },
    on: {
      "open": _vm.onSaveDataDialogOpen,
      "close": _vm.onSaveDataDialogClose
    },
    model: {
      value: (_vm.dataFileName),
      callback: function($$v) {
        _vm.dataFileName = $$v
      },
      expression: "dataFileName"
    }
  }), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.testRunning),
      expression: "testRunning"
    }],
    staticStyle: {
      "margin-left": "50px",
      "margin-top": "20px"
    },
    attrs: {
      "md-row": ""
    }
  }, [_c('md-progress', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "md-progress": _vm.progressValue
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeVoltVsTime && _vm.showVoltVsTime),
      expression: "includeVoltVsTime && showVoltVsTime"
    }],
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('div', {
    ref: "volt_vs_time_plot"
  })]), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsTime && _vm.showCurrVsTime),
      expression: "includeCurrVsTime && showCurrVsTime"
    }],
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('div', {
    ref: "curr_vs_time_plot"
  })]), _vm._v(" "), _c('md-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.includeCurrVsVolt && _vm.showCurrVsVolt),
      expression: "includeCurrVsVolt && showCurrVsVolt"
    }],
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('div', {
    ref: "volt_vs_curr_plot"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-084842bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollectData.vue
// module id = 163
// module chunks = 1